import {Component, ChangeDetectionStrategy, Inject, ViewChild, signal} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {combineLatest, of} from 'rxjs';
import {switchMap, map, first} from 'rxjs/operators';
import {MerchantDiscount} from '../../../core/dtos/api';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MerchantApiService} from '../../../core/services/api/merchant-api.service';
import {DashboardApiService} from '../../../core/services/api/dashboard-api.service';
import {MatTableDataSource} from '@angular/material/table';
import {TagApiService} from '../../../core/services/api/tag-api.service';

interface AssociatedAffiliate {
  classicId: string;
  affiliate: string;
  defaultUrl: string;
}
type AssociateAffiliateProperties = keyof AssociatedAffiliate;

@Component({
    templateUrl: './affiliate-details-dialog.component.html',
    styleUrls: ['./affiliate-details-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AffiliateDetailsDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {merchantDiscount: MerchantDiscount},
              private merchantApiService: MerchantApiService, private dashboardApiService: DashboardApiService,
              private tagApiService: TagApiService) {}

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<AssociatedAffiliate>();
  isLoadingResults = signal(true);

  readonly displayColumns: AssociateAffiliateProperties[] = ['classicId', 'affiliate', 'defaultUrl'];

  dataSource$Sub = combineLatest([of(this.data.merchantDiscount), this.dashboardApiService.currentAccount$]).pipe(
    switchMap(([merchantDiscount, currentAccount]) => {
      if (merchantDiscount.discount_entity_group_name === 'affiliates') {
        return this.merchantApiService.getRelationshipByMerchantAndAffiliate(currentAccount.entity_id, merchantDiscount.discount_entity_id).pipe(
          map(associatedAffiliate => {
            if (associatedAffiliate) {
              return [
                {
                  classicId: associatedAffiliate.classic_affiliate_id,
                  affiliate: associatedAffiliate.affiliate_name,
                  defaultUrl: associatedAffiliate.affiliate_website_url
                }
              ];
            }
            return [];
          }));
      }
      if (merchantDiscount.discount_entity_group_name === 'tag_groups') {
        return this.tagApiService.getAssociatedEntitiesOfTag(merchantDiscount.discount_entity_id, 'merchants').pipe(
          map(entities => entities.map(entity => ({
            classicId: entity.classic_entity_id,
            affiliate: entity.entity_name,
            defaultUrl: entity.entity_website_url})))
        );
      }
      return of([]);
    }),
    first()
  ).subscribe(data => {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.data = data;
    this.isLoadingResults.set(false);
  });

}
